import { Link, usePage } from "@inertiajs/react";
import {
  Building2,
  Factory,
  Home,
  Loader2,
  Network,
  ScanBarcode,
} from "lucide-react";
import { NavUser } from "@/bizminer/layouts/admin/sidebar/nav-user.tsx";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar.tsx";
import {
  bizminer_admin_industries_path,
  bizminer_admin_insight_requests_path,
  bizminer_admin_kpi_model_nodes_path,
  bizminer_admin_organizations_path,
  bizminer_admin_root_path,
  bizminer_admin_yaml_validation_path,
} from "@/routes";
import type { BizminerAdminInertiaSharedProps } from "@/types/inertia.ts";

function isActive(url: string, path: string): boolean {
  // Exact match for root, startsWith for others
  if (path === "/admin" || path === "/admin/") {
    return url === "/admin" || url === "/admin/";
  }
  return url.startsWith(path);
}

function BrandHeader() {
  return (
    <div className="flex items-center px-6 py-4">
      <div className="size-8 bg-primary rounded-md flex items-center justify-center mr-3">
        <span className="text-primary-foreground font-bold text-sm">A</span>
      </div>
      <h1 className="text-xl font-extrabold text-foreground">Admin Panel</h1>
    </div>
  );
}

const Version = ({ version }: { version: string }) => {
  return (
    <span className="text-muted-foreground text-xs ">
      <span className="font-medium">Vitelis </span>
      <span className="">{version}</span>
    </span>
  );
};

export default function AdminSidebar() {
  const {
    url,
    props: { sidebar },
  } = usePage<BizminerAdminInertiaSharedProps>();

  return (
    <Sidebar collapsible="offcanvas">
      <SidebarHeader>
        <BrandHeader />
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton asChild isActive={isActive(url, "/admin")}>
                  <Link href={bizminer_admin_root_path()}>
                    <Home />
                    <span>Overview</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  isActive={isActive(url, "/admin/organizations")}
                >
                  <Link href={bizminer_admin_organizations_path()}>
                    <Building2 />
                    <span>Organizations</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  isActive={isActive(url, "/admin/kpi_model_nodes")}
                >
                  <Link href={bizminer_admin_kpi_model_nodes_path()}>
                    <Network />
                    <span>KPI Model</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  isActive={isActive(url, "/admin/industries")}
                >
                  <Link href={bizminer_admin_industries_path()}>
                    <Factory />
                    <span>Industries</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  isActive={isActive(url, "/admin/insight_requests")}
                >
                  <Link href={bizminer_admin_insight_requests_path()}>
                    <Loader2 />
                    <span>Insight Requests</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>

        <SidebarGroup className="mt-auto">
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton
                  asChild
                  isActive={isActive(url, "/admin/yaml-validation")}
                >
                  <Link href={bizminer_admin_yaml_validation_path()}>
                    <ScanBarcode />
                    <span>YAML Validator</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter>
        <NavUser user={sidebar.user!} />
        <Version version={sidebar.version!} />
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>

    // <div className="fixed inset-y-0 left-0 z-50 w-64 bg-sidebar border-r border-sidebar-border transform transition-transform duration-300 ease-in-out lg:transform-none -translate-x-full lg:translate-x-0 flex flex-col h-screen">
    //   <BrandHeader />
    //   <MainNavigation />
    //   <div className="border-t border-border px-4 py-4">
    //     <UserProfile />
    //   </div>
    // </div>
  );
}
